import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import type { Title } from "@/types/media";
import { CATEGORY_META } from "@/lib/media";

interface TitleCardProps {
  item: Title;
  highlight?: string;
}

function highlightText(text: string, keyword?: string): ReactNode {
  if (!keyword) return text;
  const idx = text.toLowerCase().indexOf(keyword.toLowerCase());
  if (idx === -1) return text;
  return (
    <>
      {text.slice(0, idx)}
      <mark className="bg-primary-500/30 text-primary-300 rounded px-0.5">
        {text.slice(idx, idx + keyword.length)}
      </mark>
      {text.slice(idx + keyword.length)}
    </>
  );
}

export default function TitleCard({ item, highlight }: TitleCardProps) {
  const typeLabel = CATEGORY_META[item.type].label;

  return (
    <Link to={`/detail/${item.id}`} className="group block">
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-800">
        <img
          src={item.cover}
          alt={`${item.title} 高清封面`}
          title={`${item.title} 高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/30 to-transparent opacity-70" />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-semibold">
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-background-950/75 text-foreground-100 text-xs">
          {typeLabel}
        </span>
        <span className="absolute bottom-2 left-2 flex items-center gap-1 text-xs text-foreground-200">
          <i className="ri-play-circle-line text-primary-400 text-sm"></i>
          {item.views}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-3 pt-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300 hidden sm:block">
          <p className="text-xs text-foreground-200 line-clamp-2">{item.synopsis}</p>
        </div>
      </div>
      <h3 className="mt-2.5 text-sm font-medium text-foreground-100 truncate group-hover:text-primary-400 transition-colors">
        {highlightText(item.title, highlight)}
      </h3>
      <p className="text-xs text-foreground-400 mt-1 truncate">
        {item.year} · {item.region} · {item.genres.join(" / ")}
      </p>
    </Link>
  );
}